export const Money = (): JSX.Element => (
  <svg width="338" height="69" viewBox="0 0 338 69" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5882_12297)">
      <rect
        width="337"
        height="69"
        transform="translate(0.5)"
        fill="url(#paint0_linear_5882_12297)"
      />
      <rect
        x="-15.5"
        y="79.4961"
        width="38"
        height="18"
        transform="rotate(-53.369 -15.5 79.4961)"
        fill="#207955"
      />
      <path
        d="M2.51268 58.6209L7.58428 51.7997L18.8192 60.1529L13.7476 66.9741M-7.63054 72.2633L-12.7021 79.0845L-1.46723 87.4377L3.60438 80.6165"
        stroke="white"
        strokeOpacity="0.6"
      />
      <circle
        cx="3.05944"
        cy="69.6187"
        r="8"
        transform="rotate(-53.369 3.05944 69.6187)"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M2.64788 66.8203C1.76147 66.1612 0.508622 66.3455 -0.15043 67.2319C-0.809483 68.1183 -0.625172 69.3712 0.261239 70.0302C1.14765 70.6893 2.40049 70.505 3.05955 69.6186"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M3.4712 72.417C4.35761 73.076 5.61046 72.8917 6.26951 72.0053C6.92856 71.1189 6.74425 69.866 5.85784 69.207C4.97143 68.5479 3.71858 68.7322 3.05953 69.6186"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M-1.75586 66.0386L-0.953365 66.6352M7.87407 73.1985L7.07158 72.6018M0.651624 67.8286L2.25661 69.0219M5.46659 71.4085L3.8616 70.2152"
        stroke="white"
        strokeOpacity="0.6"
      />
      <rect
        x="137.376"
        y="48.8477"
        width="38"
        height="18"
        transform="rotate(-15.0166 137.376 48.8477)"
        fill="#207955"
      />
      <path
        d="M164.455 43.6542L172.665 41.4519L176.292 54.9738L168.083 57.1761M148.036 48.0589L139.826 50.2612L143.454 63.7831L151.663 61.5808"
        stroke="white"
        strokeOpacity="0.6"
      />
      <circle
        cx="158.059"
        cy="52.6174"
        r="8"
        transform="rotate(-15.0166 158.059 52.6174)"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M159.472 50.1675C159.186 49.1007 158.089 48.4678 157.023 48.754C155.956 49.0402 155.323 50.1371 155.609 51.2039C155.895 52.2708 156.992 52.9036 158.059 52.6174"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M156.645 55.0672C156.931 56.134 158.028 56.7669 159.095 56.4807C160.162 56.1945 160.795 55.0977 160.509 54.0308C160.222 52.964 159.126 52.3311 158.059 52.6173"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M156.504 46.8223L156.763 47.7881M159.613 58.4125L159.354 57.4466M157.281 49.7198L157.799 51.6515M158.836 55.5149L158.318 53.5832"
        stroke="white"
        strokeOpacity="0.6"
      />
      <rect
        x="152.09"
        y="14.4219"
        width="38"
        height="18"
        transform="rotate(29.5369 152.09 14.4219)"
        fill="#207955"
      />
      <path
        d="M175.03 29.719L182.425 33.9094L175.523 46.0899L168.128 41.8996M160.239 21.3383L152.844 17.1479L145.942 29.3285L153.337 33.5188"
        stroke="white"
        strokeOpacity="0.6"
      />
      <circle
        cx="164.183"
        cy="31.619"
        r="8"
        transform="rotate(29.5369 164.183 31.619)"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M166.909 30.8648C167.454 29.9038 167.116 28.6833 166.155 28.1388C165.194 27.5943 163.974 27.9319 163.429 28.8929C162.885 29.8539 163.222 31.0744 164.183 31.619"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M161.457 32.3731C160.913 33.3342 161.25 34.5546 162.211 35.0992C163.173 35.6437 164.393 35.3061 164.938 34.3451C165.482 33.3841 165.144 32.1636 164.183 31.619"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M167.142 26.3989L166.649 27.269M161.226 36.8394L161.719 35.9693M165.663 29.009L164.677 30.7491M162.705 34.2293L163.691 32.4892"
        stroke="white"
        strokeOpacity="0.6"
      />
      <rect
        x="237.668"
        y="15.2695"
        width="38"
        height="18"
        transform="rotate(-45 237.668 15.2695)"
        fill="#207955"
      />
      <path
        d="M258.527 -2.76169L264.538 -8.7721L274.437 1.1274L268.427 7.1378M246.507 9.25912L240.496 15.2695L250.396 25.169L256.406 19.1586"
        stroke="white"
        strokeOpacity="0.6"
      />
      <circle
        cx="257.467"
        cy="8.19849"
        r="8"
        transform="rotate(-45 257.467 8.19849)"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M257.467 5.37021C256.686 4.58916 255.42 4.58916 254.639 5.37021C253.858 6.15126 253.858 7.41759 254.639 8.19864C255.42 8.97969 256.686 8.97969 257.467 8.19864"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M257.467 11.027C258.248 11.8081 259.514 11.8081 260.295 11.027C261.076 10.246 261.076 8.97963 260.295 8.19858C259.514 7.41753 258.248 7.41753 257.467 8.19858"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M253.225 3.95581L253.932 4.66292M261.71 12.4411L261.003 11.734M255.346 6.07713L256.76 7.49134M259.589 10.3198L258.174 8.90556"
        stroke="white"
        strokeOpacity="0.6"
      />
      <rect
        x="287.089"
        y="42"
        width="38"
        height="18"
        transform="rotate(60 287.089 42)"
        fill="#207955"
      />
      <path
        d="M299.106 66.8156L303.356 74.1768L291.232 81.1768L286.982 73.8156M290.606 52.0931L286.356 44.7319L274.232 51.7319L278.482 59.0931"
        stroke="white"
        strokeOpacity="0.6"
      />
      <circle
        cx="288.794"
        cy="62.9546"
        r="8"
        transform="rotate(60 288.794 62.9546)"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M291.527 63.6865C292.483 63.1342 292.811 61.911 292.259 60.9545C291.707 59.9979 290.483 59.6701 289.527 60.2224C288.57 60.7747 288.242 61.9979 288.795 62.9545"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M286.063 62.2224C285.106 62.7747 284.779 63.9979 285.331 64.9545C285.883 65.911 287.106 66.2388 288.063 65.6865C289.019 65.1342 289.347 63.911 288.795 62.9545"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M293.991 59.9543L293.125 60.4543M283.599 65.9543L284.465 65.4543M291.393 61.4543L289.661 62.4543M286.197 64.4543L287.929 63.4543"
        stroke="white"
        strokeOpacity="0.6"
      />
      <rect
        x="72.5547"
        y="-6.95703"
        width="38"
        height="18"
        transform="rotate(-19.4611 72.5547 -6.95703)"
        fill="#207955"
      />
      <path
        d="M99.1496 -14.2333L107.164 -17.0652L111.828 -3.86509L103.814 -1.03317M83.1208 -8.56947L75.1064 -5.73755L79.7708 7.4626L87.7852 4.63068"
        stroke="white"
        strokeOpacity="0.6"
      />
      <circle
        cx="93.468"
        cy="-4.80135"
        r="8"
        transform="rotate(-19.4611 93.468 -4.80135)"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M92.2484 -2.24927C92.6164 -1.20781 93.759 -0.661867 94.8004 -1.02987C95.8419 -1.39788 96.3878 -2.54048 96.0198 -3.58194C95.6518 -4.62341 94.5092 -5.16935 93.4678 -4.80134"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M91.4688 -10.4585L91.8019 -9.51563M95.4668 0.855916L95.1336 -0.0869514M92.4683 -7.62989L93.1346 -5.74416M94.4673 -1.97269L93.8009 -3.85842"
        stroke="white"
        strokeOpacity="0.6"
      />
      <rect
        x="26.9785"
        y="8"
        width="38"
        height="18"
        transform="rotate(53.5476 26.9785 8)"
        fill="#207955"
      />
      <path
        d="M41.7095 31.3081L46.7598 38.1451L35.4989 46.4632L30.4486 39.6262M31.6089 17.6341L26.5586 10.7971L15.2977 19.1153L20.348 25.9523"
        stroke="white"
        strokeOpacity="0.6"
      />
      <circle
        cx="31.0284"
        cy="28.6302"
        r="8"
        transform="rotate(53.5476 31.0284 28.6302)"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M33.8255 29.0505C34.714 28.3942 34.9022 27.1419 34.2459 26.2535C33.5896 25.365 32.3374 25.1768 31.4489 25.8331C30.5605 26.4894 30.3722 27.7416 31.0285 28.6301"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M28.2311 28.2098C27.3427 28.8661 27.1545 30.1183 27.8107 31.0068C28.467 31.8953 29.7193 32.0835 30.6078 31.4272C31.4962 30.7709 31.6844 29.5186 31.0282 28.6302"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M35.8545 25.0652L35.0501 25.6593M26.2023 32.195L27.0066 31.6009M33.4414 26.8476L31.8327 28.036M28.6153 30.4126L30.224 29.2243"
        stroke="white"
        strokeOpacity="0.6"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5882_12297"
        x1="337"
        y1="0"
        x2="309.882"
        y2="132.448"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EEF7FD" />
        <stop offset="0.7242" stopColor="#DFF8E9" />
      </linearGradient>
      <clipPath id="clip0_5882_12297">
        <rect width="337" height="69" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
